import FetcherFactory from '../../fetcher/Fetchers/factory.js'
import {FormErrorsFactory} from '../Errors/factory.js'
import {FormMappersFactory} from '../Mappers/factory.js'
import {FormValueObjectsFactory} from '../ValueObjects/factory.js'
import {HTTPFormRepository} from './HTTPFormRepository.js'

export class FormRepositoriesFactory {
  static hTTPFormRepository = ({config}) =>
    new HTTPFormRepository({
      config,
      fetchOrFail: FetcherFactory.fetchOrFail({config}),
      specsFormValueObject: FormValueObjectsFactory.specsFormValueObject,
      specsFormError: FormErrorsFactory.specsFormError,
      captchaStatusGenericFormError: FormErrorsFactory.captchaStatusGenericFormError,
      captchaStatusNotFoundFormError: FormErrorsFactory.captchaStatusNotFoundFormError,
      captchaStatusNotActiveFormError: FormErrorsFactory.captchaStatusNotActiveFormError,
      configurationNotFoundFormError: FormErrorsFactory.configurationNotFoundFormError,
      fromCaptchaStatusResponseToCaptchaFormValueObjectMapper:
        FormMappersFactory.fromCaptchaStatusResponseToCaptchaFormValueObjectMapper(),
      fromModelDetailFormConfigResponseToModelDetailFormConfigVOMapper:
        FormMappersFactory.fromModelDetailFormConfigResponseToModelDetailFormConfigVOMapper(),
      genericFormError: FormErrorsFactory.genericFormError,
      fromSpecsFormListToSpecsDatalistValueObjectMapper:
        FormMappersFactory.fromSpecsFormListToSpecsDatalistValueObjectMapper()
    })
}
